// client/src/analytics/agile.ts
export function trackPage() {
  try {
    // @ts-ignore
    if (window?._agile?.track_page_view) {
      // @ts-ignore
      window._agile.track_page_view();
    } else if (Array.isArray((window as any)._agile)) {
      (window as any)._agile.push(["trackPageView"]);
    }
  } catch {}
}

export function trackEvent(name: string, props: Record<string, any> = {}) {
  try {
    // @ts-ignore
    if (window?._agile?.track_event) {
      // @ts-ignore
      window._agile.track_event(name, props);
    } else if (Array.isArray((window as any)._agile)) {
      (window as any)._agile.push(["trackEvent", name, props]);
    }
  } catch {}
}
